export interface ResponseDropdownSettings {
    ResponseDropdown: {
        responseActionName: string;
    };
}

export default {
    ResponseDropdown: {
        responseActionName: 'LaunchPickerInput',
    },
} as ResponseDropdownSettings;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/response-dropdown.ts